import React from "react";
import ReactDOM from "react-dom/client";
import { initializeSentry } from "utils/initializeSentry";
import ThemeModeProvider from "components/ThemeModeProvider/ThemeModeProvider";
import App from "components/App/App";

initializeSentry();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div />}>
      <ThemeModeProvider>
        <App />
      </ThemeModeProvider>
    </React.Suspense>
  </React.StrictMode>,
);
